import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseCommonLayout.module.scss'

const cx = className.bind(style)

type Props = {
  children: React.ReactNode
}

const MyhouseCommonLayout: React.FC<Props> = ({ children }: Props) => {
  return <div className={cx('article')}>{children}</div>
}

export default MyhouseCommonLayout
